export default {
    'delete': "Verwijderen",
    'cancel': "Annuleren",
    'yes': "Ja",
    'no': "Nee",
    'pdf': "PDF",
    'order': "Order",
    'my-orders': "Mijn bestellingen",
    'print-labels': "druk labels af",
    'delete-labels': "labels verwijderen",
    'mail-labels': "labels mail",
    'customer-name': "Naam klant",
    'details': "Details",
    'customer-email': "E-mail klant",
    'customer-phone': "Telefoon klant",
    'delivery-time': "Levertijd",
    'delivery-date': "Leverdatum",
    'enabled': "ingeschakeld",
    'enter-subject': "onderwerp invoeren",
    'email-subject': "e-mail onderwerp",
    'template-for': "sjabloon voor",
    'preview': "Voorbeeld",
    'template-context-info': 'Als u een vermelde variabelenaam tussen accolades plaatst, wordt de variabele in de sjabloon geïnjecteerd die naar de klant wordt verzonden.',
    'variable': "Variabel",
    'close': "Sluiten",
    'search': "Zoeken",
    'select-shipping': "Kies leveringsdatum en tijd",
    'submit': "Verzenden",
    'shopping-cart': "Winkelmandje",
    'total': "Totaal",
    'submit-order': "Order verzenden",
    'day': "Dag",
    'error-login': "Fout bij inloggen",
    'evening': "Avond",
    'notifications': "Notificaties",
    'no-hours-available': "Geen beschikbare uren, kies een andere dag.",
    'the-date-has-not': "Er is nog geen datum geselecteerd.",
    'order-not-placed': "Order nog niet geplaatst, fout!",
    'order-successfully-created': "Het order is geplaatst",
    'payment-status': "Status betaling",
    'card-holder-name': "Naam kaarthouder",
    'login': "Login",
    'login-with-google': "Login via Google",
    'login-with-github': "Login via Github",
    'dashboard': "Dashboard",
    'profile': "Profiel",
    'logout': "Uitloggen",
    'clear': "Leegmaken",
    'add-to-cart': "Toevoegen",
    'there-are-no-products': "Er zijn geen producten beschikbaar.",
    'return': "Keer terug",
    'update': "Wijzig",
    'create': "Aanmaken",
    'save': "Bewaren",
    'back': "Terug",
    'save-changes': "Bewaar de wijzigingen",
    'reset-password': "Wachtwoord opnieuw instellen",
    'created': "Aangemaakt",
    'in-processing': "In behandeling",
    'completed': "Klaar",
    'last-10-orders': "Laatste 10 orders",
    'number-of-orders': "Aantal orders",
    'payment': "Betaling",
    'my-category': "Mijn categorie",
    'new-item': "Nieuw item",
    'sort': "Sorteermodus",
    'are-you-sure-you-want': "Ben je zeker dit item te verwijderen?",
    'are-you-sure-you-want-items': "Ben je zeker deze items te verwijderen?",
    'ok': "OK",
    'select': "Selecteer",
    'your-plan-is': "Jouw plan is",
    'select-plan': "Selecteer plan",
    'no-payment-method': "Geen betalingsmethode gevonden, voeg er één toe.",
    'ending-in': "Eindigend op",
    'exp': "Exp",
    'remove': "Verwijderen",
    'you-subscribing-to': "Je schrijft je in voor",
    'edit-order': "Order aanpassen",
    'order-id': "Order id",
    'created-order': "Aangemaakt order",
    'add-variation': "Variatie toevoegen",
    'add-variation-item': "Variatie-item toevoegen",
    'delete-variation': "Variatie verwijderen",
    'variation': "variatie",
    'price-change': "Prijs wijziging",
    'variations': "Variaties",
    'variation-name': "Variatie naam",
    'variation-value': "Variatie waarde",
    'image': "Afbeelding",
    'categories': "Categorieën",
    'price': "Prijs",
    'type-here-description': "Typ hier de omschrijving...",
    'description': "Omschrijving",
    'product-name': "Product naam",
    'my-product': "Mijn product",
    'this-is-old-page': "Dit is een oude pagina, gebruik een nieuwe instellingen pagina",
    'fields': "Velden",
    'color-theme': "Kleur thema",
    'code': "Code",
    'copy': "Copy",
    'sign-up': "Aanmelden",
    'home': "Home",
    'password-reset': "Reset paswoord",
    'password': "Paswoord",
    'reset': "Reset",
    'about': "Over",
    'forgot-password': "Paswoord vergeten",
    'privacy-policy': "Privacybeleid",
    'faq': "FAQ",
    'streamlined-integration': "Geplaatst in één regel",
    'your-hassle-free': "Van bestelling tot afhaalmoment, op één plek",
    'step-1': "Stap 1",
    'let-our-experts': "We bekijken samen hoe jij werkt en wat je nodig hebt.",
    'step-2': "Stap 2",
    'smooth-onboarding': "We zetten je account klaar en helpen je op weg.",
    'step-3': "Stap 3",
    'experience-personalized': "Werkt iets niet zoals jij het wil? Dan passen we het aan.",
    'step-4': "Stap 4",
    'dive-into-comprehensive': "We tonen je hoe je producten, uren en bestellingen beheert.",
    'step-5': "Stap 5",
    'congratulations-you-are-all': "Klaar. Je eerste bestelling kan binnenkomen.",
    'get-started-for-free': "Start gratis",
    'optimize-delivery-logistics': "Bepaal zelf wanneer je bestellingen aanneemt",
    'streamline-your-delivery': "Stel je openingsuren, afhaalmomenten en verlofdagen in. Rond de feestdagen beperk je eenvoudig het aantal bestellingen per uur, zodat het werkbaar blijft achter de toog.",
    'organize-your-logistics': "Plan je afhaalmomenten",
    'improve-efficienty': "Minder fouten, minder tijdverlies",
    'attract-more-customers': "Klanten die blijven terugkomen",
    'online-booking-software': "Online booking software en een all-in platform",
    'besteller-powerful-and-simple': "Besteller - Krachtige en eenvoudige e-commerce oplossing",
    'for-scheduling': "om te plannen",
    'about-us': "Over ons",
    'clients': "Klanten",
    'free-trial': "Probeer gratis",
    'blog': "Blog",
    'contacts': "Contacten",
    'contact-us': "Contacteer ons",
    'register': "Registreer",
    'sign-in': "Aanmelden",
    'effortsless-order': "Bestellingen en producten beheren, met je eigen afhaalmomenten",
    'discover-seamless-control': "Je ziet in één oogopslag wat er besteld is, voor welke dag en voor welke klant. Producten, prijzen en afhaalmomenten beheer je zelf. Geen technische kennis nodig en geen dure koppeling met je kassa.",
    'easy-to-use': "Eenvoudig productbeheer",
    'no-need-to-pay': "Print je bestellijsten en etiketten, ook op de drukste dagen",
    'many-useful-actions': "Klaar voor de drukte",
    'online-orders-acceptance': "Bestellingen aannemen zonder telefoon",
    'get-more-orders-online': "Zet het bestelformulier op je eigen website en neem bestellingen aan buiten de openingsuren",
    'online-support': "Hulp in het Nederlands",
    'you-are-not-alone': "Je staat er niet alleen voor. Heb je een vraag, dan krijg je antwoord van iemand die het platform kent, in het Nederlands.",
    'client-database': "Client database",
    'keep-track-of-all-clients': "Keep track of all clients' data like appointment history, no shows and membership status with simple-to-use CRM software.",
    'powerful-management-tools': "Alles op één plek",
    'overview-and-manage': "Bekijk en beheer je bestellingen, producten, afhaalmomenten en openingsuren op één plek",
    'seamless-integration': "Past op je eigen website",
    'its-very-easy': "Je hoeft geen programmeur te zijn. Je krijgt één regel code die je op je website plakt, en het bestelformulier staat er. Lukt het niet, dan doen wij het voor je.",
    'inventory-and-accounting': "Inventory and accounting",
    'monitor-consumables-and-items': "Monitor consumables and items in stock with inventory tool as part of our ERP system. Get procurement, staff salaries and other expense reports.",
    'revenue-increase': "bestellingen verwerkt sinds 2023",
    'orders-this-year': "bestellingen in 2026",
    'more-monthly-orders': "klanten die opnieuw bestellen",
    'easy-to-use-solution': "regel code op je eigen website",
    '10-million': "10 million",
    'appointments-booked-per-month': "appointments booked per month",
    'professionals-available': "professionals available for online booking",
    'boost-orders-and-revenue': "Minder telefoon tijdens de drukte, meer tijd in de winkel",
    'revolutionize-your-sales': "Veel klanten bellen liever niet tijdens de middagdrukte. Met een bestelformulier op je eigen site plaatsen ze hun bestelling wanneer het hen past, en bereid jij ze rustig voor.",
    'all-in-one': "Eén formulier: bestelling, afhaalmoment en betaling",
    'easy-integration': "Werkt op de website die je al hebt",
    'user-friendly-interface': "Eenvoudig in gebruik",
    'allergenen': "Allergenen",
    'ingredients': "Ingrediënten",
    'position-must-be-positive': "Positie moet >= 0 zijn",
    'position': "Positie",
    'catalog': "Catalogus",
    'name': "Naam",
    'phone': "Telefoonnummer",
    'email': "E-mail adres",
    'log-in': "Inloggen",
    'order-details': "Order details",
    'additional-bread': "Broodproducten",
    'additional-vegetables': "Groenten & fruit",
    'additional-meat': "Vleesproducten",
    'customer_number': 'Klantnummer',
    'additional-customer-number': "Klantnummer",
    'additional-voucher-short': "Tegoedbon",
    'additional-voucher': "Tegoedbon {value} euro: Ik heb een tegoedbon van {value} euro en breng deze mee bij het afhalen van de bestelling",
    'users': "Gebruiker",
    'schedule': "Planning",
    'price-plans': "Tariefplan",
    'orders': "Bestellingen",
    'widget-settings': "Widget Instellingen",
    'shop-settings': "Winkel Instellingen",
    'products': "Product",
    'are-you-sure': "Weet je het zeker?",
    'title': "Titel",
    'qty': "Qty",
    'monthly-price': "Maandelijkse Prijs",
    'active': "Actief",
    'activated': 'Ja',
    'not_activated': 'Nee',
    'loading-please-wait': "Laden... Geduld",
    'billing': "Billing",
    'billing-checkout': "Billing checkout",
    'choose-working-hours': "Kies werkuren",
    'build-a-widget': "Een widget maken",
    'mon': "Ma",
    'tue': "Di",
    'wed': "Wo",
    'thu': "Do",
    'fri': "Vr",
    'sat': "Za",
    'sun': "Zo",
    'font': "Letter",
    'id': "id",
    'status': "Status",
    'password-confirmation': "Wachtwoord Bevestiging",
    'password-reset-confirmed': "Wachtwoord Reset Bevestigd",
    'select-a-localization': "Selecteer een lokalisatie",
    'mollie-key': "Mollie key",
    'mollie-disabled': "De Mollie-integratie is voorlopig uitgeschakeld. Neem contact op met support@matica.be.",
    'processing-time-in-hours': "Verwerkingstijd in uren",
    'open': "Open",
    'paid': "Betaald",
    'canceled': "Geannuleerd",
    'expired': "Verlopen",
    'failed': "Mislukt",
    'new': "Nieuw",
    'number-of-orders-per-hour': "Aantal bestellingen per uur",
    'time-zone': "Tijdzone",
    'text-color': "Tekstkleur",
    'image-url': "Afbeelding url",
    'type-here-ingredients': "Typ hier de ingrediënten...",
    'type-here-allergenen': "Typ hier informatie over \"allergenen\"...",
    'select-a-shop-mode': "Selecteer een winkelmodus",
    'energize-your-business': "Een bestelsysteem dat past bij een winkel, niet bij een webshop",
    'automate-your-shop': "Stel je producten, openingsuren, verlofdagen en afhaalmomenten in. Het formulier houdt er automatisch rekening mee, zodat niemand kan bestellen voor een dag dat je gesloten bent.",
    'time': "Tijd",
    'actions': "Actie",
    'date': "Datum",
    'agreement': "Overeenkomst",
    'pickup-at': "Ophalen bij",
    'amount': "Totaal",
    'we-deliver-orders': "Wij leveren bestellingen",
    'delivery-price': "Levering Prijs",
    'delivery-desc': "Levering beschrijving",
    'zipcode': "Postcode",
    'min-order-cost': "Min. Bestelkosten",
    'cost': "Kosten",
    'deliver-to-other-zipcodes': "Leveren aan andere zipcodes",
    'add-zipcodes': "Zipcodes toevoegen",
    'pick-up': "Halen",
    'delivery': "Levering",
    'address': "Adres",
    'info': "Info",
    'number-of-add-items-per-hour': "Aantal items per uur toevoegen",
    'sorry-we-dont-delivery': "Gelieve ons te contacteren om deze bestelling te kunnen valideren",
    'the-time-of-delivery-depends': "Het uur van levering is afhankelijk van het verkeer en de meest logische route. We houden zo goed als mogelijk rekening met uw gewenste leveruur. Alle lunches worden geleverd tussen 11u en 12u30, de vrijdagmiddaglevering mag u verwachten tussen 15u en 18u.",
    'all': "Alle",
    'extra_processing_time': "Extra processing time",
    'payment_method': "Betaalmethoden",
    'payment_methods': "Betaalmethoden",
    'payment_method_cash': "Contant/Op factuur",
    'payment_method_card': "Online betalen",
    'required-fields': "Verplichte velden",
    'required-end-date': "Vereiste Begindatum en einddatum",
    'required-end-time': "Vereiste begin - en eindtijd",
    'times': "Tijd",
    'dates': "Datum",
    'go-to-checkout': "Naar winkelmand",
    'vat-number': "BTW nummer",
    'today': "Vandaag",
    'yesterday': "Gisteren",
    'weekly': "Wekelijks",
    'templates': "Sjablonen",
    'subject': 'Onderwerp',
    'type': 'Type',
    'body': "kern van de brief",
    'email_subject': "Onderwerp",
    'email_text': "Tekst",
    'excel-export': "Excel exporteren",
    'holiday': "Vakantie",
    'vat-not-found': "Dit BTW-nummer is niet gevonden",
    'notify_about_promotions': "Informeer over promoties",
    'save-an-account': "Een account opslaan",
    'account': "Rekening",
    'only-pickup': "Alleen ophalen",
    'notify_order_created': 'Er is zojuist een nieuwe bestelling aangemaakt',
    'msg-orders-per-hour-is-exceeded': 'Foutmelding bij overschrijding van het aantal bestellingen per uur',
    'add-new': "Nieuw toevoegen",
    'template-select-placeholder': 'Sjabloon voor',
    'send-email': 'E-mail verzenden',
    'ready-to-go': "Klaar om te starten?",
    'lets-start': 'Laten we beginnen',
    'dialog-email-send-title': 'E-mailsjablonen',
    'repeat-last-order': 'Kopieer van vorige bestelling',
    'send-message': 'Bericht versturen',
    'message': 'Bericht',
    'unavailable-items-from-last-order': 'Sommige items van jouw vorige bestelling zijn niet beschikbaar',
    'add-item-to-cart': 'Voeg artikel toe aan de winkelwagen',
    'what-types-of-business': 'Welke soorten bedrijven kunnen profiteren van uw diensten?',
    'our-services-are-designed': 'Onze services zijn ontworpen om tegemoet te komen aan een breed scala aan bedrijven, waaronder winkels, dienstverlenende bedrijven, e-commercewebsites en meer. Of u nu een kleine start-up of een gevestigde onderneming bent, onze oplossingen kunnen worden afgestemd op uw specifieke behoeften.',
    'how-do-i-get': 'Hoe ga ik aan de slag met jullie diensten?',
    'getting-started-is-easy': 'Aan de slag gaan is eenvoudig! Meld u eenvoudig aan of klik op de knop \'Gratis aan de slag\', waarna een van onze experts contact met u opneemt om uw vereisten te bespreken en de beste oplossing voor uw bedrijf te bepalen.',
    'what-sets-your-company': 'Wat onderscheidt uw bedrijf van de concurrentie?',
    'we-pride-ourselves': 'We zijn trots op onze persoonlijke aanpak en toewijding aan klanttevredenheid. Ons begeleide installatieproces, voortdurende ondersteuning en toewijding aan voortdurende verbetering zorgen ervoor dat u het meeste uit onze services haalt. Bovendien onderscheidt onze expertise op het gebied van e-commerce ons in het leveren van op maat gemaakte oplossingen voor uw bedrijf.',
    'is-your-software': 'Is uw software compatibel met bestaande systemen of platforms?',
    'yes-our-software': 'Ja, onze software is ontworpen om naadloos te integreren met een verscheidenheid aan bestaande systemen en platforms. Of u nu WordPress, Shopify of andere applicaties van derden gebruikt, we kunnen onze oplossingen aanpassen zodat ze harmonieus samenwerken met uw huidige configuratie.',
    'how-can-i-get': 'Hoe kan ik contact opnemen met uw ondersteuningsteam als ik vragen heb of hulp nodig heb?',
    'were-here-to-help': 'Wij zijn hier om te helpen! U kunt ons supportteam bereiken via de contactpagina of onze sociale mediakanalen. Onze deskundige vertegenwoordigers zijn beschikbaar om u te helpen met eventuele vragen of problemen die u tegenkomt, zodat u verzekerd bent van een soepele ervaring met onze diensten.',
    'seamless-storefront-solution': "Online bestellingen voor beenhouwers, bakkers en traiteurs",
    'your-hassle-free-integrate': "Je klanten bestellen vooraf via je eigen website en kiezen zelf wanneer ze afhalen. Jij krijgt elke dag een duidelijke lijst. Geen webshop, geen gedoe.",
    'we-re-here-to-help': "We helpen je graag verder",
    'our-team-will-answer': "We beantwoorden je bericht binnen één werkdag",
    'nomadic-soft-stands': "Besteller.io is in handen van Matica. Wij bouwen en onderhouden websites en webapplicaties voor ondernemers, en zorgen dat dit platform blijft draaien: veilig, up-to-date en met ondersteuning in het Nederlands.",
    'for-besteller': "Besteller.io is gemaakt voor versambachten: beenhouwers, bakkers en traiteurs die hun klanten vooraf willen laten bestellen zonder een volledige webshop op te zetten. Geen voorraadbeheer, geen verzendkosten, geen ingewikkelde instellingen. Gewoon een bestelformulier dat past bij hoe een winkel werkt.",
    'demo': 'Demo',
    'convert-visits-into-sales': "Bestellingen komen binnen terwijl je werkt",
    'implements-the-shopping-cart-widget': "Je klanten bestellen wanneer het hen uitkomt, ook 's avonds en in het weekend. Ze kiezen zelf hun afhaalmoment en betalen vooraf of bij afhaling. Jij hoeft de telefoon niet meer op te nemen terwijl er volk in de winkel staat.",
    'machine': 'Afhalen aan automaat',
    'store': 'Afhalen in de winkel',
    'reset-machine': 'Deselecteren automaat',
    'vending': 'Machine',
    'machine-order': 'Machine Order',
    'archive': 'Alle bestellingen',
    'archive-text': 'Toon bestellingen die zowel zijn afgedrukt als verzonden.',
    'success-send-to-vending': 'Succes verzonden naar vending',
    'uncorrect-response-vending': 'Onjuist antwoord tijdens verzending naar vending',
    'failed-send-vending': 'Verzenden naar verkoopautomaat is mislukt',
    'required_price_field': 'Prijs vereist',
    'invalid_price_number': 'Prijs moet hoog zijn en dan 0',
    'invalid_code_length': 'Code moet 5 symbolen bevatten',
    'dialog_vending_title': 'Vul uw prijs en code in',
    '*price': '*Prijs',
    'printed': 'Gedrukt',
    'mailed': 'Gemaild',
    'schedule-vending-caption': 'Openingstijden verkoopautomaten',
    'from': 'Van',
    'to': 'Naar',
    'available': 'Beschikbaar',
    'point': 'Punt',
    'range': 'Bereik',
    'mailer-settings': 'Mailer Settings',
    'select-a-show-mode': 'Selecteer een weergavemodus voor producten',
    'end-at-available': 'Beschikbaar tot',
    'indicator-order': 'Indicator',
    'additional_fields': 'Extra velden',
    'show_details_column': 'Details kolom tonen',
    'cart_variation_editable': 'Klant mag de variatie (bv. gewicht) in de winkelwagen wijzigen',
    'orders_list_settings': 'Bestellijst',
    'orders_table_v2': 'Nieuwe bestellijst gebruiken (testversie)',
    'printing_show_ordered_at': "Toon 'Besteld op' op het etiket",
    'choose-new-password': "Nieuw wachtwoord kiezen",
    'new-password': "Nieuw wachtwoord",
    'repeat-password': "Herhaal wachtwoord",
    'save-new-password': "Opslaan",
    'password-changed-logged-in': "Je wachtwoord is gewijzigd. Je bent nu ingelogd.",
    'reset-link-expired': "Deze link is verlopen of ongeldig. Vraag een nieuwe aan via 'Wachtwoord vergeten'.",
    'customer-linked': "Je e-mailadres was al gekend. Je account werkt nu ook bij deze winkel; log in met je bestaande wachtwoord.",
    'transport': "Verzendmethode",
    'host': "Server",
    'port': "Poort",
    'username': "Gebruikersnaam",
    'encryption': "Versleuteling",
    'domain': "Domein",
    'secret': "Geheime sleutel",
    'endpoint': "Endpoint",
    'category-name': "Categorienaam",
    'client-id': "Klant-ID",
    'is_printed': "Gedrukt",
    'notified_at': "Gemaild",
    'is_viewed': "Bekeken",
    'select-label': "Selecteer:",
    'select-all': "Alles",
    'select-new': "Nieuw",
    'select-count': "{count} geselecteerd",
    'select-heading': "Selecteer",
    'print-labels-v2': "Labels afdrukken",
    'excel-short': "Excel",
    'more': "Meer",
    'mail-action': "Mailen",
    'delete-action': "Verwijderen…",
    'search-by-name': "Zoeken op naam",
    'select-not-printed': "Niet afgedrukt",
    'select-not-mailed': "Niet gemaild",
    'pickup_time': "Afhaaltijd",
    'show_more': "toon meer",
    'show_less': "toon minder",
    'tt_select_page': "Selecteer alle bestellingen op deze pagina",
    'tt_id': "Bestelnummer. Klik om te sorteren",
    'tt_indicator': "Extra's in deze bestelling: brood, groenten of vlees",
    'tt_bread': "Deze bestelling bevat brood",
    'tt_vegetables': "Deze bestelling bevat groenten",
    'tt_meat': "Deze bestelling bevat vlees",
    'tt_name': "Klant: naam, e-mail en telefoon",
    'tt_details': "Wat de klant bestelde",
    'tt_show_more': "Toon de volledige bestellijst",
    'tt_show_less': "Toon enkel de eerste 4 regels",
    'tt_pickup_time': "Dag en tijdslot die de klant koos om af te halen of te laten leveren. Klik om te sorteren",
    'tt_delivery': "Deze bestelling wordt geleverd, niet afgehaald",
    'tt_status': "Betaal- en verwerkingsstatus",
    'tt_open': "Nog niet online betaald (betaling bij afhaling of nog bezig)",
    'tt_paid': "Online betaald",
    'tt_canceled': "De online betaling werd geannuleerd",
    'tt_expired': "De online betaling is verlopen",
    'tt_failed': "De online betaling is mislukt",
    'tt_new': "Nog niet afgedrukt of nog niet gemaild",
    'tt_printed_yes': "Etiket is afgedrukt",
    'tt_printed_no': "Etiket is nog niet afgedrukt",
    'tt_mailed_yes': "Klant gemaild op {date}",
    'tt_mailed_no': "Klant is nog niet gemaild",
    'tt_total': "Totaalbedrag van de bestelling",
    'tt_show': "Bestelling bekijken",
    'tt_vending': "Afhaalcode voor de automaat aanmaken en doorsturen",
    'tt_pdf': "PDF van deze bestelling openen",
    'tt_edit': "Bestelling bewerken",
    'tt_email': "Mail sturen naar de klant (kies een sjabloon)",
    'tt_delete': "Bestelling verwijderen",
    'tt_machine': "Bestelling voor de automaat (M). Klik om te sorteren",
    'tt_machine_cell': "Bestelling voor de automaat",
    'tt_printed': "Is het etiket van deze bestelling al afgedrukt?",
    'tt_mailed': "Kreeg de klant al een mail over deze bestelling?",
    'tt_actions': "Acties voor deze bestelling",
    'tt_filter_all': "Selecteer alle bestellingen in de lijst",
    'tt_filter_new': "Selecteer de bestellingen die nog niet afgedrukt of nog niet gemaild zijn",
    'tt_filter_not_printed': "Selecteer de bestellingen waarvan het etiket nog niet afgedrukt is",
    'tt_filter_not_mailed': "Selecteer de bestellingen waarvoor de klant nog geen mail kreeg",
    'tt_select_count': "Aantal aangevinkte bestellingen. Labels afdrukken, Excel en Meer werken op deze selectie",
    'tt_filter_today': "Toon de bestellingen die vandaag afgehaald of geleverd worden (zonder \"Alle bestellingen\": enkel de nog niet afgewerkte)",
    'tt_filter_yesterday': "Toon de bestellingen die gisteren afgehaald of geleverd werden (zonder \"Alle bestellingen\": enkel de nog niet afgewerkte)",
    'tt_filter_weekly': "Toon de bestellingen met afhaaldag deze week, maandag tot zondag (zonder \"Alle bestellingen\": enkel de nog niet afgewerkte)",
    'tt_filter_excel': "De geselecteerde bestellingen downloaden als Excel-bestand",
    'tt_filter_labels_print': "De etiketten van de geselecteerde bestellingen afdrukken",
    'tt_filter_labels_delete': "De geselecteerde bestellingen verwijderen",
    'tt_filter_labels_mail': "De geselecteerde klanten mailen",
    'tt_filter_more': "Meer acties voor de geselecteerde bestellingen: mailen of verwijderen",
    'tt_filter_date': "Filter op afhaaldag (van – tot), binnen de getoonde bestellingen",
    'tt_filter_time': "Filter op tijdslot (van – tot); werkt samen met een gekozen datum",
    'tt_filter_clear': "Datum- en tijdfilter wissen",
    'tt_filter_archive': "Toon ook bestellingen die al afgedrukt én gemaild zijn",
    'tt_filter_search': "Zoek op naam van de klant",
    'period-label': "Periode",
    'show-label': "Tonen",
    'this-week': "Deze week",
    'machine-only': "Enkel automaat",
    'clear-all-filters': "Alle filters wissen",
    'tt_filter_machine_only': "Toon enkel bestellingen voor de automaat",
    'tt_filter_clear_all': "Zet periode, datum, tijd, Alle bestellingen en Enkel automaat terug. Het zoekveld blijft staan.",
    'tt_nav_toggle': "Navigatie in- of uitklappen",
}
